var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyClipboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_18739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20.5C13.3375 20.5 12.9844 20.3531 12.6906 20.0594C12.3969 19.7656 12.25 19.4125 12.25 19V10C12.25 9.5875 12.3969 9.23438 12.6906 8.94063C12.9844 8.64688 13.3375 8.5 13.75 8.5H20.5C20.9125 8.5 21.2656 8.64688 21.5594 8.94063C21.8531 9.23438 22 9.5875 22 10V19C22 19.4125 21.8531 19.7656 21.5594 20.0594C21.2656 20.3531 20.9125 20.5 20.5 20.5H13.75ZM13.75 19H20.5V10H13.75V19ZM10.75 23.5C10.3375 23.5 9.98438 23.3531 9.69063 23.0594C9.39688 22.7656 9.25 22.4125 9.25 22V11.5H10.75V22H19V23.5H10.75Z",
    fill: "#A3A9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_18739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyClipboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy_clipboard.2865c64dfb35ad74415002db68d02fdb.svg";